// extracted by mini-css-extract-plugin
export default {"main":"aG8SY","titleWraper":"vrSbK","title":"SdiKd","clear":"tAudP","requestTitle":"eNIw9"};